export function BrandLogo() {
  return <img className="ziheng-logo" src="/images/brand/ziheng-logo-web-v1.png" width={162} height={54} alt="Ziheng 紫衡" decoding="async" />;
}
